import { render, staticRenderFns } from "./BpsMessageToaster.vue?vue&type=template&id=737ae357&scoped=true&"
import script from "./BpsMessageToaster.vue?vue&type=script&lang=ts&"
export * from "./BpsMessageToaster.vue?vue&type=script&lang=ts&"
import style0 from "./BpsMessageToaster.vue?vue&type=style&index=0&id=737ae357&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737ae357",
  null
  
)

export default component.exports